export const rootPath = '/';
export const imagesPath = '/images/:filterId/:reviewedAfter/:page/:imageIdx?';
export const uploadPath = '/uploads/:page?/:fileId?';
export const userManagementPath = '/users';


export const imagesRoute = (filterId: string, reviewedAfter: string | number, page: string | number, imageIdx?: string | number) => 
    `/images/${filterId}/${reviewedAfter}/${page}${imageIdx !== undefined ? `/${imageIdx}` : ''}`;

export const uploadedFilesRoute = (page: string | number, fileId?: string | number) => {
    page = page || 0;
    return `/uploads/${page}${fileId !== undefined ? `/${fileId}` : ''}`;
}

export interface PagedRoute {
    page: string
}

export interface ImagesRoute extends PagedRoute {
    filterId: string, 
    reviewedAfter: string,
    imageIdx?: string
}

export interface UploadedFilesRoute extends PagedRoute { 
    fileId?: string
}